import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import { Table } from 'primeng/table';
import {NavService} from '../../../_services/_nav.service';
import {AutenticacionService} from '../../../_services/autenticacion.service';
import {FuncionalidadControl} from '../../../_models/funcionalidad-control';
import {Observable, Subscription} from 'rxjs';
import { RolFunctionalidadControl } from '../../../_models/rol-functionalidad-control';
import { RolFuncionalitiesServices } from '../../../_services/rol-funcionalidad.service';

@Component( {
  selector: 'app-datatable-controles',
  templateUrl: 'datatable-controles.component.html'
} )

export class DatatableControlesComponent implements OnInit, OnDestroy {

  @Input() listaFuncionalidadesControles: FuncionalidadControl[] = [];
  @Input() pasoFlujo: string;
  @Input() ordenBusqueda: Observable<any>;
  @Output() actualizarListaControles: EventEmitter<any> = new EventEmitter<any>();
  carTabla = true;
  columnas: any[] = [];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  busquedaSuscripcion: Subscription;
  lisRoles: RolFunctionalidadControl[] = [];
  colRoles: any[] = [];
  objControlSeleccionado: FuncionalidadControl;
  mosModalRoles = false;

  constructor( private navService: NavService,
               private autService: AutenticacionService,
               private rolFuncionalidadControlService: RolFuncionalitiesServices) {
  }

  ngOnInit(): void {

    if ( this.ordenBusqueda ){
      this.busquedaSuscripcion = this.ordenBusqueda.subscribe( data => {
        console.log('realizando busqueda');
        this.realizarBusqueda();
      });
    }

    this.columnas = [
      { field: 'codigo', header: this.navService.buscarMensaje( 'DATATABLECONTROLES.LBL_CODIGO' ), sort: false },
      { field: 'nombre', header: this.navService.buscarMensaje( 'DATATABLECONTROLES.LBL_NOMBRECAMPO' ), sort: false },
      { field: 'indicadorVisible', header: this.navService.buscarMensaje( 'DATATABLECONTROLES.LBL_VISIBLE' ), sort: false },
      { field: 'det', header: this.navService.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.colRoles = [
      { field: 'rol', header: this.navService.buscarMensaje( 'FLUJOVENTA.LBL_ROL' ), sort: false },
      { field: 'indicadorEditar', header: this.navService.buscarMensaje( 'FLUJOVENTA.LBL_EDITAR' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navService.buscarMensaje( 'FLUJOVENTA.LBL_VISUALIZAR' ), sort: false }
    ];
    this.busqueda = this.navService.getSearch( 'datatable-controles-' + this.pasoFlujo );
    this.carTabla = false;
  }

  ngOnDestroy() {
    if ( this.busquedaSuscripcion ) {
      this.busquedaSuscripcion.unsubscribe();
      this.busquedaSuscripcion = null;
    }
  }

  setBusqueda() {
    this.navService.setSearch( 'datatable-controles-' + this.pasoFlujo, this.busqueda );
  }

  verRoles( elemento: FuncionalidadControl ) {
    this.carTabla = true;
    this.rolFuncionalidadControlService.getByIdFuncionalidadControlEnabled( elemento.idFuncionalidadControl ).subscribe( lis => {
      this.carTabla = false;
      if ( lis.length === 0 ) {
        this.navService.setMesage( 0, {
          severity: 'info', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navService.buscarMensaje( 'FLUJOVENTA.MSG_NOEXISTEROLCONF' )
        } );
        return;
      }
      this.mosModalRoles = true;
      this.objControlSeleccionado = elemento;
      this.lisRoles = lis;
    } );
  }

  cerrarRoles() {
    this.mosModalRoles = false;
  }

  realizarBusqueda() {
    setTimeout( () => {
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    }, 30 );
  }
}
